module.exports = __webpack_public_path__ + "img/title-left3.117a1ee.png";